module.exports = __webpack_public_path__ + "img/btnCard-8.5c0d9937.jpg";